export enum LogisticRouteName {
  LIST = 'logistic-offer-list',
  EDIT = 'edit-logistic-offer',
}
